// import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';

// // Accordion
// class AccordionCustom extends HTMLElement {
//   /** @type {HTMLDetailsElement} */
//   get details() {
//     const details = this.querySelector('details');

//     if (!(details instanceof HTMLDetailsElement)) throw new Error('Details element not found');

//     return details;
//   }

//   /** @type {HTMLElement} */
//   get summary() {
//     const summary = this.details.querySelector('summary');

//     if (!(summary instanceof HTMLElement)) throw new Error('Summary element not found');

//     return summary;
//   }

//   get #disableOnMobile() {
//     return this.dataset.disableOnMobile === 'true';
//   }

//   get #disableOnDesktop() {
//     return this.dataset.disableOnDesktop === 'true';
//   }

//   get #closeWithEscape() {
//     return this.dataset.closeWithEscape === 'true';
//   }

//   #controller = new AbortController();

//   connectedCallback() {
//     const { signal } = this.#controller;

//     this.#setDefaultOpenState();

//     this.addEventListener('keydown', this.#handleKeyDown, { signal });
//     this.summary.addEventListener('click', this.handleClick, { signal });
//     mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange, { signal });
//   }

//   /**
//    * Handles the disconnect event.
//    */
//   disconnectedCallback() {
//     // Disconnect all the event listeners
//     this.#controller.abort();
//   }

//   /**
//    * Handles the click event.
//    * @param {Event} event - The event.
//    */
//   handleClick = (event) => {
//     const isMobile = isMobileBreakpoint();
//     const isDesktop = !isMobile;

//     // Stop default behaviour from the browser
//     if ((isMobile && this.#disableOnMobile) || (isDesktop && this.#disableOnDesktop)) {
//       event.preventDefault();
//       return;
//     }

//     // Only apply single-open logic for accordions with this specific class
//     if (this.classList.contains('custom-behaviour')) {
//     setTimeout(() => {
//       if (this.details.open) {
//         const parent = this.parentElement;

//         parent?.querySelectorAll('accordion-custom.custom-behaviour').forEach((el) => {
//           if (el !== this && el instanceof AccordionCustom && el.details.open) {
//             el.details.open = false;
//           }
//         });

//         // Scroll the opened accordion into view with offset
//         const offset = 100; // Offset in pixels from the top
//         const rect = this.getBoundingClientRect();
//         const absoluteTop = window.pageYOffset + rect.top - offset;

//         window.scrollTo({
//           top: absoluteTop,
//           behavior: 'smooth'
//         });
//       }
//   }
// }
//   };

//   /**
//    * Handles the media query change event.
//    */
//   #handleMediaQueryChange = () => {
//     this.#setDefaultOpenState();
//   };

//   /**
//    * Sets the default open state of the accordion based on the `open-by-default-on-mobile` and `open-by-default-on-desktop` attributes.
//    */
//   #setDefaultOpenState() {
//     const isMobile = isMobileBreakpoint();

//     this.details.open =
//       (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
//       (!isMobile && this.hasAttribute('open-by-default-on-desktop'));
//   }

//   /**
//    * Handles keydown events for the accordion
//    *
//    * @param {KeyboardEvent} event - The keyboard event.
//    */
//   #handleKeyDown(event) {
//     // Close the accordion when used as a menu
//     if (event.key === 'Escape' && this.#closeWithEscape) {
//       event.preventDefault();

//       this.details.open = false;
//       this.summary.focus();
//     }
//   }
// }

// if (!customElements.get('accordion-custom')) {
//   customElements.define('accordion-custom', AccordionCustom);
// }

import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';

// Accordion
class AccordionCustom extends HTMLElement {
  /** @type {HTMLDetailsElement} */
  get details() {
    const details = this.querySelector('details');

    if (!(details instanceof HTMLDetailsElement)) throw new Error('Details element not found');

    return details;
  }

  /** @type {HTMLElement} */
  get summary() {
    const summary = this.details.querySelector('summary');

    if (!(summary instanceof HTMLElement)) throw new Error('Summary element not found');

    return summary;
  }

  get #disableOnMobile() {
    return this.dataset.disableOnMobile === 'true';
  }

  get #disableOnDesktop() {
    return this.dataset.disableOnDesktop === 'true';
  }

  get #closeWithEscape() {
    return this.dataset.closeWithEscape === 'true';
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.#setDefaultOpenState();

    this.addEventListener('keydown', this.#handleKeyDown, { signal });
    this.summary.addEventListener('click', this.handleClick, { signal });
    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange, { signal });
  }

  /**
   * Handles the disconnect event.
   */
  disconnectedCallback() {
    // Disconnect all the event listeners
    this.#controller.abort();
  }

  /**
   * Handles the click event.
   * @param {Event} event - The event.
   */
  handleClick = (event) => {
    const isMobile = isMobileBreakpoint();
    const isDesktop = !isMobile;

    // Stop default behaviour from the browser
    if ((isMobile && this.#disableOnMobile) || (isDesktop && this.#disableOnDesktop)) {
      event.preventDefault();
      return;
    }

    // Only apply single-open logic for accordions with this specific class
    if (this.classList.contains('custom-behaviour')) {
      event.preventDefault(); // Prevent default to handle open/close manually

      const wasOpen = this.details.open;
      const parent = this.parentElement;

      // Close all accordions first
      parent?.querySelectorAll('accordion-custom.custom-behaviour').forEach((el) => {
        if (el instanceof AccordionCustom) {
          el.details.open = false;
        }
      });

      // If it wasn't open before, open it and scroll
      if (!wasOpen) {
        this.details.open = true;

        // Find the parent accordion section and scroll it into view with offset
        const accordionSection = this.closest('.accordion');
        if (accordionSection) {
          const yOffset = -80; // Offset for fixed header
          const y = accordionSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }
    }

    // Apply single-open logic for accordions with custom-behaviour-2 class
    if (this.classList.contains('custom-behaviour-2')) {
      event.preventDefault(); // Prevent default to handle open/close manually

      const wasOpen = this.details.open;
      const parent = this.parentElement;

      // Close all accordions first
      parent?.querySelectorAll('accordion-custom.custom-behaviour-2').forEach((el) => {
        if (el instanceof AccordionCustom) {
          el.details.open = false;
        }
      });

      if (!wasOpen) {
        this.details.open = true;

        // Check if content is out of view and scroll accordingly
        setTimeout(() => {
          const accordionRect = this.getBoundingClientRect();
          const contentElement = this.querySelector('.details-content');
          
          if (contentElement) {
            const contentRect = contentElement.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            
            // Check if any part of the content is cut off or mostly out of view
            const buffer = 80; 
            const isContentCutOff = contentRect.bottom > (viewportHeight - buffer);
            const isAccordionPartiallyVisible = accordionRect.bottom > viewportHeight;
            
            if (isContentCutOff || isAccordionPartiallyVisible) {
              // Scroll to position accordion in the upper-center area of viewport
              const yOffset = -(viewportHeight * 0.25); // Position at 25% down from top
              const y = accordionRect.top + window.pageYOffset + yOffset;
              
              window.scrollTo({ 
                top: y, 
                behavior: 'smooth' 
              });
            }
            // If content is in view, do nothing
          }
        }, 50); 
      }
    }
  };

  /**
   * Handles the media query change event.
   */
  #handleMediaQueryChange = () => {
    this.#setDefaultOpenState();
  };

  /**
   * Sets the default open state of the accordion based on the `open-by-default-on-mobile` and `open-by-default-on-desktop` attributes.
   */
  #setDefaultOpenState() {
    const isMobile = isMobileBreakpoint();

    this.details.open =
      (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
      (!isMobile && this.hasAttribute('open-by-default-on-desktop'));
  }

  /**
   * Handles keydown events for the accordion
   *
   * @param {KeyboardEvent} event - The keyboard event.
   */
  #handleKeyDown(event) {
    // Close the accordion when used as a menu
    if (event.key === 'Escape' && this.#closeWithEscape) {
      event.preventDefault();

      this.details.open = false;
      this.summary.focus();
    }
  }
}

if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}



